export default "__VITE_ASSET__CcXCQF0e__"